import { jsx as M, jsxs as ee, Fragment as lt } from "react/jsx-runtime";
import { useRef as he, useLayoutEffect as Re, forwardRef as dt, useState as le, useCallback as q, useMemo as E, createElement as ft, useImperativeHandle as mt, useEffect as ge, memo as De } from "react";
import { t as ht } from "./throttle-CbOTDqvg.mjs";
import { c as H } from "./tw-cn-mXgPecoF.mjs";
import { u as gt } from "./use-isomorphic-layout-effect-m4WLzKHG.mjs";
import { I as yt, a as wt } from "./ic_arrowforward_fill-BQJduMXz.mjs";
import { I as We } from "./icon-button-CBGiAhhG.mjs";
function bt(t, e, n = "long") {
  return new Intl.DateTimeFormat("en-US", {
    // Enforces engine to render the time. Without the option JavaScriptCore omits it.
    hour: "numeric",
    timeZone: t,
    timeZoneName: n
  }).format(e).split(/\s/g).slice(2).join(" ");
}
const Me = {}, ue = {};
function z(t, e) {
  try {
    const a = (Me[t] || (Me[t] = new Intl.DateTimeFormat("en-US", {
      timeZone: t,
      timeZoneName: "longOffset"
    }).format))(e).split("GMT")[1];
    return a in ue ? ue[a] : Ye(a, a.split(":"));
  } catch {
    if (t in ue) return ue[t];
    const n = t == null ? void 0 : t.match(Dt);
    return n ? Ye(t, n.slice(1)) : NaN;
  }
}
const Dt = /([+-]\d\d):?(\d\d)?/;
function Ye(t, e) {
  const n = +(e[0] || 0), a = +(e[1] || 0), r = +(e[2] || 0) / 60;
  return ue[t] = n * 60 + a > 0 ? n * 60 + a + r : n * 60 - a - r;
}
class U extends Date {
  //#region static
  constructor(...e) {
    super(), e.length > 1 && typeof e[e.length - 1] == "string" && (this.timeZone = e.pop()), this.internal = /* @__PURE__ */ new Date(), isNaN(z(this.timeZone, this)) ? this.setTime(NaN) : e.length ? typeof e[0] == "number" && (e.length === 1 || e.length === 2 && typeof e[1] != "number") ? this.setTime(e[0]) : typeof e[0] == "string" ? this.setTime(+new Date(e[0])) : e[0] instanceof Date ? this.setTime(+e[0]) : (this.setTime(+new Date(...e)), ze(this, e)) : this.setTime(Date.now());
  }
  static tz(e, ...n) {
    return n.length ? new U(...n, e) : new U(Date.now(), e);
  }
  //#endregion
  //#region time zone
  withTimeZone(e) {
    return new U(+this, e);
  }
  getTimezoneOffset() {
    const e = -z(this.timeZone, this);
    return e > 0 ? Math.floor(e) : Math.ceil(e);
  }
  //#endregion
  //#region time
  setTime(e) {
    return Date.prototype.setTime.apply(this, arguments), ye(this), +this;
  }
  //#endregion
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](e) {
    return new U(+new Date(e), this.timeZone);
  }
  //#endregion
}
const pe = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((t) => {
  if (!pe.test(t)) return;
  const e = t.replace(pe, "$1UTC");
  U.prototype[e] && (t.startsWith("get") ? U.prototype[t] = function() {
    return this.internal[e]();
  } : (U.prototype[t] = function() {
    return Date.prototype[e].apply(this.internal, arguments), Tt(this), +this;
  }, U.prototype[e] = function() {
    return Date.prototype[e].apply(this, arguments), ye(this), +this;
  }));
});
function ye(t) {
  t.internal.setTime(+t), t.internal.setUTCSeconds(t.internal.getUTCSeconds() - // Round after converting minutes to seconds to avoid fractional offset
  // precision errors from historical offsets.
  Math.round(-z(t.timeZone, t) * 60));
}
function Tt(t) {
  Date.prototype.setFullYear.call(t, t.internal.getUTCFullYear(), t.internal.getUTCMonth(), t.internal.getUTCDate()), Date.prototype.setHours.call(t, t.internal.getUTCHours(), t.internal.getUTCMinutes(), t.internal.getUTCSeconds(), t.internal.getUTCMilliseconds()), ze(t);
}
function ze(t, e) {
  const n = Array.isArray(e) ? St(e) : +t.internal, a = z(t.timeZone, t), r = a > 0 ? Math.floor(a) : Math.ceil(a), s = /* @__PURE__ */ new Date(+t);
  s.setUTCHours(s.getUTCHours() - 1);
  const c = -(/* @__PURE__ */ new Date(+t)).getTimezoneOffset(), i = -(/* @__PURE__ */ new Date(+s)).getTimezoneOffset(), m = c - i;
  let o = c;
  if (m && c !== r) {
    const F = Date.prototype.getHours.apply(t), A = Array.isArray(e) ? e[3] || 0 : t.internal.getUTCHours();
    if (F !== A) {
      const b = /* @__PURE__ */ new Date(+t), P = c - r;
      P && b.setUTCMinutes(b.getUTCMinutes() + P);
      const p = z(t.timeZone, b);
      (p > 0 ? Math.floor(p) : Math.ceil(p)) === r && (o = i);
    }
  }
  const d = o - r;
  d && Date.prototype.setUTCMinutes.call(t, Date.prototype.getUTCMinutes.call(t) + d);
  const u = /* @__PURE__ */ new Date(+t);
  u.setUTCSeconds(0);
  const l = c > 0 ? u.getSeconds() : (u.getSeconds() - 60) % 60, f = Math.round(-(z(t.timeZone, t) * 60)) % 60;
  (f || l) && Date.prototype.setUTCSeconds.call(t, Date.prototype.getUTCSeconds.call(t) + f + l);
  const h = z(t.timeZone, t), g = h > 0 ? Math.floor(h) : Math.ceil(h), N = -(/* @__PURE__ */ new Date(+t)).getTimezoneOffset() - g, D = g !== r, y = N - d, v = g - r, T = n - g * 60 * 1e3, w = v > 0 && Fe(t) - n === v * 60 * 1e3 && Fe(t, T) !== n;
  if (D && y && !w) {
    Date.prototype.setUTCMinutes.call(t, Date.prototype.getUTCMinutes.call(t) + y);
    const F = z(t.timeZone, t), A = F > 0 ? Math.floor(F) : Math.ceil(F), b = g - A;
    b && y < 0 && Date.prototype.setUTCMinutes.call(t, Date.prototype.getUTCMinutes.call(t) + b);
  }
  ye(t);
  const k = (e ? n : n + f * 1e3) - +t.internal;
  k && Math.abs(k) < 30 * 60 * 1e3 && (Date.prototype.setTime.call(t, +t + k), ye(t));
}
function St(t) {
  return Date.UTC(t[0], t.length > 1 ? t[1] : 0, t.length > 2 ? t[2] : 1, ...t.slice(3));
}
function Fe(t, e) {
  const n = new Date(e ?? +t);
  return n.setUTCSeconds(n.getUTCSeconds() - Math.round(-z(t.timeZone, n) * 60)), +n;
}
class K extends U {
  //#region static
  static tz(e, ...n) {
    return n.length ? new K(...n, e) : new K(Date.now(), e);
  }
  //#endregion
  //#region representation
  toISOString() {
    const [e, n, a] = this.tzComponents(), r = `${e}${n}:${a}`;
    return this.internal.toISOString().slice(0, -1) + r;
  }
  toString() {
    return `${this.toDateString()} ${this.toTimeString()}`;
  }
  toDateString() {
    const [e, n, a, r] = this.internal.toUTCString().split(" ");
    return `${e == null ? void 0 : e.slice(0, -1)} ${a} ${n} ${r}`;
  }
  toTimeString() {
    const e = this.internal.toUTCString().split(" ")[4], [n, a, r] = this.tzComponents();
    return `${e} GMT${n}${a}${r} (${bt(this.timeZone, this)})`;
  }
  toLocaleString(e, n) {
    return Date.prototype.toLocaleString.call(this, e, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  toLocaleDateString(e, n) {
    return Date.prototype.toLocaleDateString.call(this, e, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  toLocaleTimeString(e, n) {
    return Date.prototype.toLocaleTimeString.call(this, e, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  //#endregion
  //#region private
  tzComponents() {
    const e = this.getTimezoneOffset(), n = e > 0 ? "-" : "+", a = String(Math.floor(Math.abs(e) / 60)).padStart(2, "0"), r = String(Math.abs(e) % 60).padStart(2, "0");
    return [n, a, r];
  }
  //#endregion
  withTimeZone(e) {
    return new K(+this, e);
  }
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](e) {
    return new K(+new Date(e), this.timeZone);
  }
  //#endregion
}
const qe = 6048e5, Mt = 864e5, Be = 6e4, Ve = 36e5, Ee = Symbol.for("constructDateFrom");
function $(t, e) {
  return typeof t == "function" ? t(e) : t && typeof t == "object" && Ee in t ? t[Ee](e) : t instanceof Date ? new t.constructor(e) : new Date(e);
}
function x(t, e) {
  return $(e || t, t);
}
function te(t, e, n) {
  const a = x(t, n == null ? void 0 : n.in);
  return isNaN(e) ? $(t, NaN) : (e && a.setDate(a.getDate() + e), a);
}
function Ot(t, e, n) {
  const a = x(t, n == null ? void 0 : n.in);
  if (isNaN(e)) return $(t, NaN);
  if (!e)
    return a;
  const r = a.getDate(), s = $(t, a.getTime());
  s.setMonth(a.getMonth() + e + 1, 0);
  const c = s.getDate();
  return r >= c ? s : (a.setFullYear(
    s.getFullYear(),
    s.getMonth(),
    r
  ), a);
}
let vt = {};
function Te() {
  return vt;
}
function fe(t, e) {
  var i, m, o, d;
  const n = Te(), a = (e == null ? void 0 : e.weekStartsOn) ?? ((m = (i = e == null ? void 0 : e.locale) == null ? void 0 : i.options) == null ? void 0 : m.weekStartsOn) ?? n.weekStartsOn ?? ((d = (o = n.locale) == null ? void 0 : o.options) == null ? void 0 : d.weekStartsOn) ?? 0, r = x(t, e == null ? void 0 : e.in), s = r.getDay(), c = (s < a ? 7 : 0) + s - a;
  return r.setDate(r.getDate() - c), r.setHours(0, 0, 0, 0), r;
}
function we(t, e) {
  return fe(t, { ...e, weekStartsOn: 1 });
}
function Xe(t, e) {
  const n = x(t, e == null ? void 0 : e.in), a = n.getFullYear(), r = $(n, 0);
  r.setFullYear(a + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const s = we(r), c = $(n, 0);
  c.setFullYear(a, 0, 4), c.setHours(0, 0, 0, 0);
  const i = we(c);
  return n.getTime() >= s.getTime() ? a + 1 : n.getTime() >= i.getTime() ? a : a - 1;
}
function Ie(t) {
  const e = x(t), n = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return n.setUTCFullYear(e.getFullYear()), +t - +n;
}
function Ne(t, ...e) {
  const n = $.bind(
    null,
    e.find((a) => typeof a == "object")
  );
  return e.map(n);
}
function be(t, e) {
  const n = x(t, e == null ? void 0 : e.in);
  return n.setHours(0, 0, 0, 0), n;
}
function xe(t, e, n) {
  const [a, r] = Ne(
    n == null ? void 0 : n.in,
    t,
    e
  ), s = be(a), c = be(r), i = +s - Ie(s), m = +c - Ie(c);
  return Math.round((i - m) / Mt);
}
function Pt(t, e) {
  const n = Xe(t, e), a = $(t, 0);
  return a.setFullYear(n, 0, 4), a.setHours(0, 0, 0, 0), we(a);
}
function Z(t, e, n) {
  const [a, r] = Ne(
    n == null ? void 0 : n.in,
    t,
    e
  );
  return +be(a) == +be(r);
}
function xt(t) {
  return t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function Nt(t) {
  return !(!xt(t) && typeof t != "number" || isNaN(+x(t)));
}
function kt(t, e, n) {
  const [a, r] = Ne(
    n == null ? void 0 : n.in,
    t,
    e
  ), s = a.getFullYear() - r.getFullYear(), c = a.getMonth() - r.getMonth();
  return s * 12 + c;
}
function Ct(t, e) {
  const n = x(t, e == null ? void 0 : e.in), a = n.getMonth();
  return n.setFullYear(n.getFullYear(), a + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function Oe(t, e) {
  const n = x(t, e == null ? void 0 : e.in);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function Wt(t, e) {
  const n = x(t, e == null ? void 0 : e.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
const Yt = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, pt = (t, e, n) => {
  let a;
  const r = Yt[t];
  return typeof r == "string" ? a = r : e === 1 ? a = r.one : a = r.other.replace("{{count}}", e.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + a : a + " ago" : a;
};
function re(t) {
  return (e = {}) => {
    const n = e.width ? String(e.width) : t.defaultWidth;
    return t.formats[n] || t.formats[t.defaultWidth];
  };
}
const Ft = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Et = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, It = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, $t = {
  date: re({
    formats: Ft,
    defaultWidth: "full"
  }),
  time: re({
    formats: Et,
    defaultWidth: "full"
  }),
  dateTime: re({
    formats: It,
    defaultWidth: "full"
  })
}, Ht = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Lt = (t, e, n, a) => Ht[t];
function _(t) {
  return (e, n) => {
    const a = n != null && n.context ? String(n.context) : "standalone";
    let r;
    if (a === "formatting" && t.formattingValues) {
      const c = t.defaultFormattingWidth || t.defaultWidth, i = n != null && n.width ? String(n.width) : c;
      r = t.formattingValues[i] || t.formattingValues[c];
    } else {
      const c = t.defaultWidth, i = n != null && n.width ? String(n.width) : t.defaultWidth;
      r = t.values[i] || t.values[c];
    }
    const s = t.argumentCallback ? t.argumentCallback(e) : e;
    return r[s];
  };
}
const _t = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, jt = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Ut = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, At = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, Rt = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, zt = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, qt = (t, e) => {
  const n = Number(t), a = n % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, Bt = {
  ordinalNumber: qt,
  era: _({
    values: _t,
    defaultWidth: "wide"
  }),
  quarter: _({
    values: jt,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: _({
    values: Ut,
    defaultWidth: "wide"
  }),
  day: _({
    values: At,
    defaultWidth: "wide"
  }),
  dayPeriod: _({
    values: Rt,
    defaultWidth: "wide",
    formattingValues: zt,
    defaultFormattingWidth: "wide"
  })
};
function j(t) {
  return (e, n = {}) => {
    const a = n.width, r = a && t.matchPatterns[a] || t.matchPatterns[t.defaultMatchWidth], s = e.match(r);
    if (!s)
      return null;
    const c = s[0], i = a && t.parsePatterns[a] || t.parsePatterns[t.defaultParseWidth], m = Array.isArray(i) ? Xt(i, (u) => u.test(c)) : (
      // [TODO] -- I challenge you to fix the type
      Vt(i, (u) => u.test(c))
    );
    let o;
    o = t.valueCallback ? t.valueCallback(m) : m, o = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(o)
    ) : o;
    const d = e.slice(c.length);
    return { value: o, rest: d };
  };
}
function Vt(t, e) {
  for (const n in t)
    if (Object.prototype.hasOwnProperty.call(t, n) && e(t[n]))
      return n;
}
function Xt(t, e) {
  for (let n = 0; n < t.length; n++)
    if (e(t[n]))
      return n;
}
function Qe(t) {
  return (e, n = {}) => {
    const a = e.match(t.matchPattern);
    if (!a) return null;
    const r = a[0], s = e.match(t.parsePattern);
    if (!s) return null;
    let c = t.valueCallback ? t.valueCallback(s[0]) : s[0];
    c = n.valueCallback ? n.valueCallback(c) : c;
    const i = e.slice(r.length);
    return { value: c, rest: i };
  };
}
const Qt = /^(\d+)(th|st|nd|rd)?/i, Gt = /\d+/i, Zt = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Jt = {
  any: [/^b/i, /^(a|c)/i]
}, Kt = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, en = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, tn = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, nn = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, an = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, rn = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, sn = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, on = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, cn = {
  ordinalNumber: Qe({
    matchPattern: Qt,
    parsePattern: Gt,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: j({
    matchPatterns: Zt,
    defaultMatchWidth: "wide",
    parsePatterns: Jt,
    defaultParseWidth: "any"
  }),
  quarter: j({
    matchPatterns: Kt,
    defaultMatchWidth: "wide",
    parsePatterns: en,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: j({
    matchPatterns: tn,
    defaultMatchWidth: "wide",
    parsePatterns: nn,
    defaultParseWidth: "any"
  }),
  day: j({
    matchPatterns: an,
    defaultMatchWidth: "wide",
    parsePatterns: rn,
    defaultParseWidth: "any"
  }),
  dayPeriod: j({
    matchPatterns: sn,
    defaultMatchWidth: "any",
    parsePatterns: on,
    defaultParseWidth: "any"
  })
}, un = {
  code: "en-US",
  formatDistance: pt,
  formatLong: $t,
  formatRelative: Lt,
  localize: Bt,
  match: cn,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function ln(t, e) {
  const n = x(t, e == null ? void 0 : e.in);
  return xe(n, Wt(n)) + 1;
}
function dn(t, e) {
  const n = x(t, e == null ? void 0 : e.in), a = +we(n) - +Pt(n);
  return Math.round(a / qe) + 1;
}
function Ge(t, e) {
  var d, u, l, f;
  const n = x(t, e == null ? void 0 : e.in), a = n.getFullYear(), r = Te(), s = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((u = (d = e == null ? void 0 : e.locale) == null ? void 0 : d.options) == null ? void 0 : u.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((f = (l = r.locale) == null ? void 0 : l.options) == null ? void 0 : f.firstWeekContainsDate) ?? 1, c = $((e == null ? void 0 : e.in) || t, 0);
  c.setFullYear(a + 1, 0, s), c.setHours(0, 0, 0, 0);
  const i = fe(c, e), m = $((e == null ? void 0 : e.in) || t, 0);
  m.setFullYear(a, 0, s), m.setHours(0, 0, 0, 0);
  const o = fe(m, e);
  return +n >= +i ? a + 1 : +n >= +o ? a : a - 1;
}
function fn(t, e) {
  var i, m, o, d;
  const n = Te(), a = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((m = (i = e == null ? void 0 : e.locale) == null ? void 0 : i.options) == null ? void 0 : m.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((d = (o = n.locale) == null ? void 0 : o.options) == null ? void 0 : d.firstWeekContainsDate) ?? 1, r = Ge(t, e), s = $((e == null ? void 0 : e.in) || t, 0);
  return s.setFullYear(r, 0, a), s.setHours(0, 0, 0, 0), fe(s, e);
}
function mn(t, e) {
  const n = x(t, e == null ? void 0 : e.in), a = +fe(n, e) - +fn(n, e);
  return Math.round(a / qe) + 1;
}
function O(t, e) {
  const n = t < 0 ? "-" : "", a = Math.abs(t).toString().padStart(e, "0");
  return n + a;
}
const G = {
  // Year
  y(t, e) {
    const n = t.getFullYear(), a = n > 0 ? n : 1 - n;
    return O(e === "yy" ? a % 100 : a, e.length);
  },
  // Month
  M(t, e) {
    const n = t.getMonth();
    return e === "M" ? String(n + 1) : O(n + 1, 2);
  },
  // Day of the month
  d(t, e) {
    return O(t.getDate(), e.length);
  },
  // AM or PM
  a(t, e) {
    const n = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(t, e) {
    return O(t.getHours() % 12 || 12, e.length);
  },
  // Hour [0-23]
  H(t, e) {
    return O(t.getHours(), e.length);
  },
  // Minute
  m(t, e) {
    return O(t.getMinutes(), e.length);
  },
  // Second
  s(t, e) {
    return O(t.getSeconds(), e.length);
  },
  // Fraction of second
  S(t, e) {
    const n = e.length, a = t.getMilliseconds(), r = Math.trunc(
      a * Math.pow(10, n - 3)
    );
    return O(r, e.length);
  }
}, ae = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, $e = {
  // Era
  G: function(t, e, n) {
    const a = t.getFullYear() > 0 ? 1 : 0;
    switch (e) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(a, { width: "abbreviated" });
      case "GGGGG":
        return n.era(a, { width: "narrow" });
      case "GGGG":
      default:
        return n.era(a, { width: "wide" });
    }
  },
  // Year
  y: function(t, e, n) {
    if (e === "yo") {
      const a = t.getFullYear(), r = a > 0 ? a : 1 - a;
      return n.ordinalNumber(r, { unit: "year" });
    }
    return G.y(t, e);
  },
  // Local week-numbering year
  Y: function(t, e, n, a) {
    const r = Ge(t, a), s = r > 0 ? r : 1 - r;
    if (e === "YY") {
      const c = s % 100;
      return O(c, 2);
    }
    return e === "Yo" ? n.ordinalNumber(s, { unit: "year" }) : O(s, e.length);
  },
  // ISO week-numbering year
  R: function(t, e) {
    const n = Xe(t);
    return O(n, e.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, e) {
    const n = t.getFullYear();
    return O(n, e.length);
  },
  // Quarter
  Q: function(t, e, n) {
    const a = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      case "Q":
        return String(a);
      case "QQ":
        return O(a, 2);
      case "Qo":
        return n.ordinalNumber(a, { unit: "quarter" });
      case "QQQ":
        return n.quarter(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(a, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, e, n) {
    const a = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      case "q":
        return String(a);
      case "qq":
        return O(a, 2);
      case "qo":
        return n.ordinalNumber(a, { unit: "quarter" });
      case "qqq":
        return n.quarter(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(a, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, e, n) {
    const a = t.getMonth();
    switch (e) {
      case "M":
      case "MM":
        return G.M(t, e);
      case "Mo":
        return n.ordinalNumber(a + 1, { unit: "month" });
      case "MMM":
        return n.month(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(a, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(a, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(t, e, n) {
    const a = t.getMonth();
    switch (e) {
      case "L":
        return String(a + 1);
      case "LL":
        return O(a + 1, 2);
      case "Lo":
        return n.ordinalNumber(a + 1, { unit: "month" });
      case "LLL":
        return n.month(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(a, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(a, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(t, e, n, a) {
    const r = mn(t, a);
    return e === "wo" ? n.ordinalNumber(r, { unit: "week" }) : O(r, e.length);
  },
  // ISO week of year
  I: function(t, e, n) {
    const a = dn(t);
    return e === "Io" ? n.ordinalNumber(a, { unit: "week" }) : O(a, e.length);
  },
  // Day of the month
  d: function(t, e, n) {
    return e === "do" ? n.ordinalNumber(t.getDate(), { unit: "date" }) : G.d(t, e);
  },
  // Day of year
  D: function(t, e, n) {
    const a = ln(t);
    return e === "Do" ? n.ordinalNumber(a, { unit: "dayOfYear" }) : O(a, e.length);
  },
  // Day of week
  E: function(t, e, n) {
    const a = t.getDay();
    switch (e) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, e, n, a) {
    const r = t.getDay(), s = (r - a.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      case "e":
        return String(s);
      case "ee":
        return O(s, 2);
      case "eo":
        return n.ordinalNumber(s, { unit: "day" });
      case "eee":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, e, n, a) {
    const r = t.getDay(), s = (r - a.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      case "c":
        return String(s);
      case "cc":
        return O(s, e.length);
      case "co":
        return n.ordinalNumber(s, { unit: "day" });
      case "ccc":
        return n.day(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(r, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(r, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, e, n) {
    const a = t.getDay(), r = a === 0 ? 7 : a;
    switch (e) {
      case "i":
        return String(r);
      case "ii":
        return O(r, e.length);
      case "io":
        return n.ordinalNumber(r, { unit: "day" });
      case "iii":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, e, n) {
    const r = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, e, n) {
    const a = t.getHours();
    let r;
    switch (a === 12 ? r = ae.noon : a === 0 ? r = ae.midnight : r = a / 12 >= 1 ? "pm" : "am", e) {
      case "b":
      case "bb":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, e, n) {
    const a = t.getHours();
    let r;
    switch (a >= 17 ? r = ae.evening : a >= 12 ? r = ae.afternoon : a >= 4 ? r = ae.morning : r = ae.night, e) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, e, n) {
    if (e === "ho") {
      let a = t.getHours() % 12;
      return a === 0 && (a = 12), n.ordinalNumber(a, { unit: "hour" });
    }
    return G.h(t, e);
  },
  // Hour [0-23]
  H: function(t, e, n) {
    return e === "Ho" ? n.ordinalNumber(t.getHours(), { unit: "hour" }) : G.H(t, e);
  },
  // Hour [0-11]
  K: function(t, e, n) {
    const a = t.getHours() % 12;
    return e === "Ko" ? n.ordinalNumber(a, { unit: "hour" }) : O(a, e.length);
  },
  // Hour [1-24]
  k: function(t, e, n) {
    let a = t.getHours();
    return a === 0 && (a = 24), e === "ko" ? n.ordinalNumber(a, { unit: "hour" }) : O(a, e.length);
  },
  // Minute
  m: function(t, e, n) {
    return e === "mo" ? n.ordinalNumber(t.getMinutes(), { unit: "minute" }) : G.m(t, e);
  },
  // Second
  s: function(t, e, n) {
    return e === "so" ? n.ordinalNumber(t.getSeconds(), { unit: "second" }) : G.s(t, e);
  },
  // Fraction of second
  S: function(t, e) {
    return G.S(t, e);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, e, n) {
    const a = t.getTimezoneOffset();
    if (a === 0)
      return "Z";
    switch (e) {
      case "X":
        return Le(a);
      case "XXXX":
      case "XX":
        return J(a);
      case "XXXXX":
      case "XXX":
      default:
        return J(a, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, e, n) {
    const a = t.getTimezoneOffset();
    switch (e) {
      case "x":
        return Le(a);
      case "xxxx":
      case "xx":
        return J(a);
      case "xxxxx":
      case "xxx":
      default:
        return J(a, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, e, n) {
    const a = t.getTimezoneOffset();
    switch (e) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + He(a, ":");
      case "OOOO":
      default:
        return "GMT" + J(a, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, e, n) {
    const a = t.getTimezoneOffset();
    switch (e) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + He(a, ":");
      case "zzzz":
      default:
        return "GMT" + J(a, ":");
    }
  },
  // Seconds timestamp
  t: function(t, e, n) {
    const a = Math.trunc(+t / 1e3);
    return O(a, e.length);
  },
  // Milliseconds timestamp
  T: function(t, e, n) {
    return O(+t, e.length);
  }
};
function He(t, e = "") {
  const n = t > 0 ? "-" : "+", a = Math.abs(t), r = Math.trunc(a / 60), s = a % 60;
  return s === 0 ? n + String(r) : n + String(r) + e + O(s, 2);
}
function Le(t, e) {
  return t % 60 === 0 ? (t > 0 ? "-" : "+") + O(Math.abs(t) / 60, 2) : J(t, e);
}
function J(t, e = "") {
  const n = t > 0 ? "-" : "+", a = Math.abs(t), r = O(Math.trunc(a / 60), 2), s = O(a % 60, 2);
  return n + r + e + s;
}
const _e = (t, e) => {
  switch (t) {
    case "P":
      return e.date({ width: "short" });
    case "PP":
      return e.date({ width: "medium" });
    case "PPP":
      return e.date({ width: "long" });
    case "PPPP":
    default:
      return e.date({ width: "full" });
  }
}, Ze = (t, e) => {
  switch (t) {
    case "p":
      return e.time({ width: "short" });
    case "pp":
      return e.time({ width: "medium" });
    case "ppp":
      return e.time({ width: "long" });
    case "pppp":
    default:
      return e.time({ width: "full" });
  }
}, hn = (t, e) => {
  const n = t.match(/(P+)(p+)?/) || [], a = n[1], r = n[2];
  if (!r)
    return _e(t, e);
  let s;
  switch (a) {
    case "P":
      s = e.dateTime({ width: "short" });
      break;
    case "PP":
      s = e.dateTime({ width: "medium" });
      break;
    case "PPP":
      s = e.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      s = e.dateTime({ width: "full" });
      break;
  }
  return s.replace("{{date}}", _e(a, e)).replace("{{time}}", Ze(r, e));
}, gn = {
  p: Ze,
  P: hn
}, yn = /^D+$/, wn = /^Y+$/, bn = ["D", "DD", "YY", "YYYY"];
function Dn(t) {
  return yn.test(t);
}
function Tn(t) {
  return wn.test(t);
}
function Sn(t, e, n) {
  const a = Mn(t, e, n);
  if (console.warn(a), bn.includes(t)) throw new RangeError(a);
}
function Mn(t, e, n) {
  const a = t[0] === "Y" ? "years" : "days of the month";
  return `Use \`${t.toLowerCase()}\` instead of \`${t}\` (in \`${e}\`) for formatting ${a} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const On = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, vn = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Pn = /^'([^]*?)'?$/, xn = /''/g, Nn = /[a-zA-Z]/;
function se(t, e, n) {
  var d, u, l, f, h, g, Y, N;
  const a = Te(), r = (n == null ? void 0 : n.locale) ?? a.locale ?? un, s = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((u = (d = n == null ? void 0 : n.locale) == null ? void 0 : d.options) == null ? void 0 : u.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((f = (l = a.locale) == null ? void 0 : l.options) == null ? void 0 : f.firstWeekContainsDate) ?? 1, c = (n == null ? void 0 : n.weekStartsOn) ?? ((g = (h = n == null ? void 0 : n.locale) == null ? void 0 : h.options) == null ? void 0 : g.weekStartsOn) ?? a.weekStartsOn ?? ((N = (Y = a.locale) == null ? void 0 : Y.options) == null ? void 0 : N.weekStartsOn) ?? 0, i = x(t, n == null ? void 0 : n.in);
  if (!Nt(i))
    throw new RangeError("Invalid time value");
  let m = e.match(vn).map((D) => {
    const y = D[0];
    if (y === "p" || y === "P") {
      const v = gn[y];
      return v(D, r.formatLong);
    }
    return D;
  }).join("").match(On).map((D) => {
    if (D === "''")
      return { isToken: !1, value: "'" };
    const y = D[0];
    if (y === "'")
      return { isToken: !1, value: kn(D) };
    if ($e[y])
      return { isToken: !0, value: D };
    if (y.match(Nn))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + y + "`"
      );
    return { isToken: !1, value: D };
  });
  r.localize.preprocessor && (m = r.localize.preprocessor(i, m));
  const o = {
    firstWeekContainsDate: s,
    weekStartsOn: c,
    locale: r
  };
  return m.map((D) => {
    if (!D.isToken) return D.value;
    const y = D.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && Tn(y) || !(n != null && n.useAdditionalDayOfYearTokens) && Dn(y)) && Sn(y, e, String(t));
    const v = $e[y[0]];
    return v(i, y, r.localize, o);
  }).join("");
}
function kn(t) {
  const e = t.match(Pn);
  return e ? e[1].replace(xn, "'") : t;
}
function ve(t, e) {
  return +x(t) > +x(e);
}
function de(t, e) {
  return +x(t) < +x(e);
}
function je(t, e) {
  return +x(t) == +x(e);
}
function Cn(t, e, n) {
  return te(t, -1, n);
}
function Je(t, e) {
  const n = () => $(e == null ? void 0 : e.in, NaN), r = Fn(t);
  let s;
  if (r.date) {
    const o = En(r.date, 2);
    s = In(o.restDateString, o.year);
  }
  if (!s || isNaN(+s)) return n();
  const c = +s;
  let i = 0, m;
  if (r.time && (i = $n(r.time), isNaN(i)))
    return n();
  if (r.timezone) {
    if (m = Hn(r.timezone), isNaN(m)) return n();
  } else {
    const o = new Date(c + i), d = x(0, e == null ? void 0 : e.in);
    return d.setFullYear(
      o.getUTCFullYear(),
      o.getUTCMonth(),
      o.getUTCDate()
    ), d.setHours(
      o.getUTCHours(),
      o.getUTCMinutes(),
      o.getUTCSeconds(),
      o.getUTCMilliseconds()
    ), d;
  }
  return x(c + i + m, e == null ? void 0 : e.in);
}
const me = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, Wn = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, Yn = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, pn = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function Fn(t) {
  const e = {}, n = t.split(me.dateTimeDelimiter);
  let a;
  if (n.length > 2)
    return e;
  if (/:/.test(n[0]) ? a = n[0] : (e.date = n[0], a = n[1], me.timeZoneDelimiter.test(e.date) && (e.date = t.split(me.timeZoneDelimiter)[0], a = t.substr(
    e.date.length,
    t.length
  ))), a) {
    const r = me.timezone.exec(a);
    r ? (e.time = a.replace(r[1], ""), e.timezone = r[1]) : e.time = a;
  }
  return e;
}
function En(t, e) {
  const n = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + e) + "})|(\\d{2}|[+-]\\d{" + (2 + e) + "})$)"
  ), a = t.match(n);
  if (!a) return { year: NaN, restDateString: "" };
  const r = a[1] ? parseInt(a[1]) : null, s = a[2] ? parseInt(a[2]) : null;
  return {
    year: s === null ? r : s * 100,
    restDateString: t.slice((a[1] || a[2]).length)
  };
}
function In(t, e) {
  if (e === null) return /* @__PURE__ */ new Date(NaN);
  const n = t.match(Wn);
  if (!n) return /* @__PURE__ */ new Date(NaN);
  const a = !!n[4], r = ce(n[1]), s = ce(n[2]) - 1, c = ce(n[3]), i = ce(n[4]), m = ce(n[5]) - 1;
  if (a)
    return An(e, i, m) ? Ln(e, i, m) : /* @__PURE__ */ new Date(NaN);
  {
    const o = /* @__PURE__ */ new Date(0);
    return !jn(e, s, c) || !Un(e, r) ? /* @__PURE__ */ new Date(NaN) : (o.setUTCFullYear(e, s, Math.max(r, c)), o);
  }
}
function ce(t) {
  return t ? parseInt(t) : 1;
}
function $n(t) {
  const e = t.match(Yn);
  if (!e) return NaN;
  const n = Pe(e[1]), a = Pe(e[2]), r = Pe(e[3]);
  return Rn(n, a, r) ? n * Ve + a * Be + r * 1e3 : NaN;
}
function Pe(t) {
  return t && parseFloat(t.replace(",", ".")) || 0;
}
function Hn(t) {
  if (t === "Z") return 0;
  const e = t.match(pn);
  if (!e) return 0;
  const n = e[1] === "+" ? -1 : 1, a = parseInt(e[2]), r = e[3] && parseInt(e[3]) || 0;
  return zn(a, r) ? n * (a * Ve + r * Be) : NaN;
}
function Ln(t, e, n) {
  const a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(t, 0, 4);
  const r = a.getUTCDay() || 7, s = (e - 1) * 7 + n + 1 - r;
  return a.setUTCDate(a.getUTCDate() + s), a;
}
const _n = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function Ke(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
function jn(t, e, n) {
  return e >= 0 && e <= 11 && n >= 1 && n <= (_n[e] || (Ke(t) ? 29 : 28));
}
function Un(t, e) {
  return e >= 1 && e <= (Ke(t) ? 366 : 365);
}
function An(t, e, n) {
  return e >= 1 && e <= 53 && n >= 0 && n <= 6;
}
function Rn(t, e, n) {
  return t === 24 ? e === 0 && n === 0 : n >= 0 && n < 60 && e >= 0 && e < 60 && t >= 0 && t < 25;
}
function zn(t, e) {
  return e >= 0 && e <= 59;
}
const et = (t) => {
  const e = he(null);
  return Re(() => {
    var a, r;
    if (t.height !== null && t.height !== void 0)
      return;
    const n = (a = e.current) == null ? void 0 : a.getBoundingClientRect().height;
    n && ((r = t.updateHeight) == null || r.call(t, n, t.index));
  }, [t]), /* @__PURE__ */ M(
    "div",
    {
      className: `absolute w-full ${t.isVisible ? "visible" : "invisible"}`,
      ref: e,
      style: { top: `${t.offsetTop}px` },
      children: t.render()
    }
  );
};
et.displayName = "NDS.VirtualListItem";
const tt = dt(
  ({
    items: t,
    listHeight: e,
    updateHeight: n,
    preLoadingThreshold: a = 50,
    updateInterval: r = 80,
    scrollRef: s,
    footer: c,
    header: i,
    className: m,
    ...o
  }, d) => {
    const [u, l] = le([]), f = he(), [h, g] = le(0), [Y, N] = le(e || 0), D = he(null), y = q(
      (() => {
        const T = ht(g, r, {
          leading: !0,
          trailing: !0
        });
        return (w) => {
          const S = w.currentTarget.scrollTop;
          T(S);
        };
      })(),
      [r]
    ), v = E(() => {
      if (u.length === 0)
        return;
      const T = a, w = Math.max(
        0,
        u.findIndex((b) => b >= h - T)
      ), S = u.findIndex((b) => b >= h + Y + T, w), k = t.slice(w, S < 0 ? t.length : S), F = u.slice(w, S < 0 ? t.length : S), A = u.length === 1 || u.length > 1 && u.some((b) => b !== 0);
      return k.map((b, P) => /* @__PURE__ */ ft(
        et,
        {
          ...b,
          index: w + P,
          isVisible: A,
          key: P,
          offsetTop: F[P],
          updateHeight: n
        },
        b.render()
      ));
    }, [t, u, h, Y, n, a]);
    return mt(
      s,
      () => ({
        scrollByItemIndex: async (T, w = 0) => {
          await new Promise((S) => {
            setTimeout(() => {
              S();
            }, 0);
          }), D.current && f.current && (D.current.scrollTop = f.current[T] + w);
        }
      }),
      [u]
    ), Re(() => {
      const T = t.reduce(
        (w, S) => (w.currentOffset += S.height || 0, w.offsetList.push(w.currentOffset), w),
        { currentOffset: 0, offsetList: [0] }
      );
      l(T.offsetList), f.current = T.offsetList;
    }, [t]), ge(() => {
      const T = () => {
        var w;
        N(((w = D.current) == null ? void 0 : w.getBoundingClientRect().height) || 0);
      };
      return T(), window.addEventListener("resize", T), () => {
        window.removeEventListener("resize", T);
      };
    }, []), /* @__PURE__ */ ee(
      "div",
      {
        ...o,
        className: H("relative size-full overflow-y-auto", m),
        onScroll: (T) => {
          var w;
          (w = o.onScroll) == null || w.call(o, T), y(T);
        },
        ref: (T) => {
          T && (D.current = T, d && typeof d != "string" && "current" in d && (d.current = T));
        },
        children: [
          i,
          /* @__PURE__ */ M("div", { style: { height: `${e}px`, width: "100%" }, children: v }),
          c
        ]
      }
    );
  }
);
tt.displayName = "NDS.VirtualList";
const qn = ["일", "월", "화", "수", "목", "금", "토"], nt = ({ deviceType: t, className: e }) => {
  const n = t === "etc";
  return /* @__PURE__ */ M("div", { className: H("grid min-h-32 grid-cols-7 text-text-neutral-main", e), children: qn.map((a, r) => /* @__PURE__ */ M(
    "div",
    {
      className: H("px-18 py-6 text-center", n ? "typography-body-14-regular" : "typography-body-13-regular"),
      children: a
    },
    `${a}_${r}`
  )) });
};
nt.displayName = "NDS.DayPickerWeeks";
const Bn = ({ type: t, className: e }) => /* @__PURE__ */ M(lt, { children: t === "start" ? /* @__PURE__ */ M(
  "svg",
  {
    className: e,
    fill: "none",
    height: "36",
    viewBox: "0 0 40 36",
    width: "40",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ M(
      "path",
      {
        d: "M0 8C0 3.58172 3.58172 0 8 0H25.7782C28.8039 0 31.5707 1.70699 32.928 4.41112L40 18.5L32.9691 31.7499C31.5814 34.365 28.8629 36 25.9024 36H8C3.58172 36 0 32.4183 0 28V8Z",
        fill: "#1B1C1F"
      }
    )
  }
) : /* @__PURE__ */ M(
  "svg",
  {
    className: e,
    fill: "none",
    height: "36",
    viewBox: "0 0 40 36",
    width: "40",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ M(
      "path",
      {
        d: "M40 8C40 3.58172 36.4183 0 32 0H14.2218C11.1961 0 8.42931 1.70699 7.07196 4.41112L0 18.5L7.03086 31.7499C8.41856 34.365 11.1371 36 14.0976 36H32C36.4183 36 40 32.4183 40 28V8Z",
        fill: "#1B1C1F",
        id: "Selected"
      }
    )
  }
) }), at = (t) => {
  const { day: e, isPc: n, className: a, dayDescriptions: r, onSelectDate: s, calendarSelectType: c } = t, { date: i, dateType: m, dateObject: o, isSelected: d, isFirstSelected: u, isLastSelected: l, isToday: f, disabled: h } = e, g = c === "single", Y = (u || l) && !g, N = u && l && g, D = E(() => m === "sunday" || m === "holiday", [m]), y = E(() => m === "empty", [m]), v = E(() => y ? "" : u && (r != null && r[0]) ? r[0] : l && (r != null && r[1]) ? r[1] : e.text, [y, u, r, l, e.text]), T = q(() => {
    s == null || s(o);
  }, [o, s]);
  return /* @__PURE__ */ ee(
    "div",
    {
      className: "relative flex w-full min-w-40 flex-col items-center justify-center",
      "data-datetype": m,
      "data-day": o ? se(o, "yyyy-MM-dd") : void 0,
      "data-disabled": h || void 0,
      "data-month": o ? se(o, "yyyy-MM") : void 0,
      "data-selected": d || void 0,
      "data-today": f,
      children: [
        /* @__PURE__ */ M(
          "div",
          {
            className: H("absolute left-0 right-0 top-0 h-36 w-full", {
              "bg-fill-neutral-weak1": d && !(u && l),
              "left-auto w-1/2": !y && u,
              "right-auto w-1/2": !y && l
            })
          }
        ),
        /* @__PURE__ */ ee(
          "button",
          {
            className: H(
              "relative flex h-36 w-36 items-center justify-center rounded-full text-text-neutral-main",
              n ? "typography-subtitle-18-bold" : "typography-subtitle-16-bold",
              {
                invisible: y
              },
              {
                // TODO: sunday와 holiday 색상 확인 필요
                "!text-text-danger-main": D,
                "bg-background": d,
                "!text-static-white": u || l,
                "!cursor-not-allowed !opacity-30": h && !d,
                "cursor-pointer rounded-full border-2 border-solid border-line-neutral-weak2 bg-transparent opacity-100": !u && !l && !d && f
              },
              a
            ),
            disabled: h,
            onClick: T,
            type: "button",
            children: [
              /* @__PURE__ */ M("span", { className: "z-20", children: i }),
              Y ? /* @__PURE__ */ M(
                Bn,
                {
                  className: H("absolute top-0 h-36 w-40", u ? "-left-1" : "-right-1"),
                  type: u ? "start" : "end"
                }
              ) : null,
              N ? /* @__PURE__ */ M("span", { className: "absolute left-1/2 top-0 h-36 w-40 -translate-x-1/2 rounded-8 bg-text-neutral-main" }) : null
            ]
          }
        ),
        /* @__PURE__ */ M("span", { className: "flex h-15 flex-col items-center justify-center pt-2 text-text-neutral-sub typography-caption-11-regular", children: v })
      ]
    }
  );
};
at.displayName = "NDS.CalendarDay";
const Vn = De(at), ke = (t) => {
  const {
    id: e,
    month: n,
    days: a,
    year: r,
    dayDescriptions: s,
    isPc: c,
    showWeeks: i,
    className: m,
    styles: o,
    onSelectDate: d,
    calendarSelectType: u
  } = t, l = n.toString().padStart(2, "0"), f = E(
    () => Array.from({ length: a.length / 7 }, (h, g) => a.slice(g * 7, (g + 1) * 7)),
    [a]
  );
  return /* @__PURE__ */ ee("div", { className: H("w-full", m), id: e, style: o, children: [
    /* @__PURE__ */ M("div", { className: "relative flex items-center justify-center pt-1", children: /* @__PURE__ */ ee("span", { className: H(c ? "py-16 typography-subtitle-18-bold" : "py-12 typography-subtitle-16-bold"), children: [
      r,
      ".",
      l
    ] }) }),
    !!i && /* @__PURE__ */ M(nt, { className: "mb-4" }),
    /* @__PURE__ */ M("div", { className: "flex w-full min-w-[280px] flex-col gap-6", role: "grid", children: f.map((h, g) => /* @__PURE__ */ M("div", { className: "grid w-full grid-cols-7 gap-0", children: h.map((Y, N) => /* @__PURE__ */ M(
      Vn,
      {
        calendarSelectType: u,
        className: Y.className,
        day: Y,
        dayDescriptions: s,
        isPc: c,
        onSelectDate: d
      },
      `${r}-${n}-${N}`
    )) }, `${r}-${n}-${g}`)) })
  ] });
};
ke.displayName = "NDS.CalendarMonth";
const Xn = De(ke), Qn = {
  lessThanXSeconds: {
    one: "1초 미만",
    other: "{{count}}초 미만"
  },
  xSeconds: {
    one: "1초",
    other: "{{count}}초"
  },
  halfAMinute: "30초",
  lessThanXMinutes: {
    one: "1분 미만",
    other: "{{count}}분 미만"
  },
  xMinutes: {
    one: "1분",
    other: "{{count}}분"
  },
  aboutXHours: {
    one: "약 1시간",
    other: "약 {{count}}시간"
  },
  xHours: {
    one: "1시간",
    other: "{{count}}시간"
  },
  xDays: {
    one: "1일",
    other: "{{count}}일"
  },
  aboutXWeeks: {
    one: "약 1주",
    other: "약 {{count}}주"
  },
  xWeeks: {
    one: "1주",
    other: "{{count}}주"
  },
  aboutXMonths: {
    one: "약 1개월",
    other: "약 {{count}}개월"
  },
  xMonths: {
    one: "1개월",
    other: "{{count}}개월"
  },
  aboutXYears: {
    one: "약 1년",
    other: "약 {{count}}년"
  },
  xYears: {
    one: "1년",
    other: "{{count}}년"
  },
  overXYears: {
    one: "1년 이상",
    other: "{{count}}년 이상"
  },
  almostXYears: {
    one: "거의 1년",
    other: "거의 {{count}}년"
  }
}, Gn = (t, e, n) => {
  let a;
  const r = Qn[t];
  return typeof r == "string" ? a = r : e === 1 ? a = r.one : a = r.other.replace("{{count}}", e.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? a + " 후" : a + " 전" : a;
}, Zn = {
  full: "y년 M월 d일 EEEE",
  long: "y년 M월 d일",
  medium: "y.MM.dd",
  short: "y.MM.dd"
}, Jn = {
  full: "a H시 mm분 ss초 zzzz",
  long: "a H:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Kn = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, ea = {
  date: re({
    formats: Zn,
    defaultWidth: "full"
  }),
  time: re({
    formats: Jn,
    defaultWidth: "full"
  }),
  dateTime: re({
    formats: Kn,
    defaultWidth: "full"
  })
}, ta = {
  lastWeek: "'지난' eeee p",
  yesterday: "'어제' p",
  today: "'오늘' p",
  tomorrow: "'내일' p",
  nextWeek: "'다음' eeee p",
  other: "P"
}, na = (t, e, n, a) => ta[t], aa = {
  narrow: ["BC", "AD"],
  abbreviated: ["BC", "AD"],
  wide: ["기원전", "서기"]
}, ra = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1분기", "2분기", "3분기", "4분기"]
}, sa = {
  narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
  abbreviated: [
    "1월",
    "2월",
    "3월",
    "4월",
    "5월",
    "6월",
    "7월",
    "8월",
    "9월",
    "10월",
    "11월",
    "12월"
  ],
  wide: [
    "1월",
    "2월",
    "3월",
    "4월",
    "5월",
    "6월",
    "7월",
    "8월",
    "9월",
    "10월",
    "11월",
    "12월"
  ]
}, ia = {
  narrow: ["일", "월", "화", "수", "목", "금", "토"],
  short: ["일", "월", "화", "수", "목", "금", "토"],
  abbreviated: ["일", "월", "화", "수", "목", "금", "토"],
  wide: ["일요일", "월요일", "화요일", "수요일", "목요일", "금요일", "토요일"]
}, oa = {
  narrow: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  },
  abbreviated: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  },
  wide: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  }
}, ca = {
  narrow: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  },
  abbreviated: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  },
  wide: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  }
}, ua = (t, e) => {
  const n = Number(t);
  switch (String(e == null ? void 0 : e.unit)) {
    case "minute":
    case "second":
      return String(n);
    case "date":
      return n + "일";
    default:
      return n + "번째";
  }
}, la = {
  ordinalNumber: ua,
  era: _({
    values: aa,
    defaultWidth: "wide"
  }),
  quarter: _({
    values: ra,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: _({
    values: sa,
    defaultWidth: "wide"
  }),
  day: _({
    values: ia,
    defaultWidth: "wide"
  }),
  dayPeriod: _({
    values: oa,
    defaultWidth: "wide",
    formattingValues: ca,
    defaultFormattingWidth: "wide"
  })
}, da = /^(\d+)(일|번째)?/i, fa = /\d+/i, ma = {
  narrow: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(기원전|서기)/i
}, ha = {
  any: [/^(bc|기원전)/i, /^(ad|서기)/i]
}, ga = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]사?분기/i
}, ya = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, wa = {
  narrow: /^(1[012]|[123456789])/,
  abbreviated: /^(1[012]|[123456789])월/i,
  wide: /^(1[012]|[123456789])월/i
}, ba = {
  any: [
    /^1월?$/,
    /^2/,
    /^3/,
    /^4/,
    /^5/,
    /^6/,
    /^7/,
    /^8/,
    /^9/,
    /^10/,
    /^11/,
    /^12/
  ]
}, Da = {
  narrow: /^[일월화수목금토]/,
  short: /^[일월화수목금토]/,
  abbreviated: /^[일월화수목금토]/,
  wide: /^[일월화수목금토]요일/
}, Ta = {
  any: [/^일/, /^월/, /^화/, /^수/, /^목/, /^금/, /^토/]
}, Sa = {
  any: /^(am|pm|오전|오후|자정|정오|아침|저녁|밤)/i
}, Ma = {
  any: {
    am: /^(am|오전)/i,
    pm: /^(pm|오후)/i,
    midnight: /^자정/i,
    noon: /^정오/i,
    morning: /^아침/i,
    afternoon: /^오후/i,
    evening: /^저녁/i,
    night: /^밤/i
  }
}, Oa = {
  ordinalNumber: Qe({
    matchPattern: da,
    parsePattern: fa,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: j({
    matchPatterns: ma,
    defaultMatchWidth: "wide",
    parsePatterns: ha,
    defaultParseWidth: "any"
  }),
  quarter: j({
    matchPatterns: ga,
    defaultMatchWidth: "wide",
    parsePatterns: ya,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: j({
    matchPatterns: wa,
    defaultMatchWidth: "wide",
    parsePatterns: ba,
    defaultParseWidth: "any"
  }),
  day: j({
    matchPatterns: Da,
    defaultMatchWidth: "wide",
    parsePatterns: Ta,
    defaultParseWidth: "any"
  }),
  dayPeriod: j({
    matchPatterns: Sa,
    defaultMatchWidth: "any",
    parsePatterns: Ma,
    defaultParseWidth: "any"
  })
}, Ue = {
  code: "ko",
  formatDistance: Gn,
  formatLong: ea,
  formatRelative: na,
  localize: la,
  match: Oa,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, va = 365, Pa = 1, xa = "지금부터", rt = (t) => {
  const e = E(() => {
    var u;
    const [c, i] = [Oe(t.from), Oe(t.to)], m = kt(i, c) + 1, o = Array.from({ length: m }, (l, f) => Ot(c, f)), d = (u = t.holidays) == null ? void 0 : u.reduce(
      (l, f) => (l[f.toDateString()] = f, l),
      {}
    );
    return o.map((l) => {
      const f = Oe(l), h = Ct(l), g = xe(h, f) + 1, Y = (S) => {
        const k = S.getDay(), F = d != null && d[S.toDateString()] ? "holiday" : (() => {
          switch (k) {
            case 0:
              return "sunday";
            case 6:
              return "saturday";
            default:
              return "weekday";
          }
        })();
        return {
          date: S.getDate(),
          dateType: F,
          dateObject: S
        };
      }, N = Array.from({ length: g }, (S, k) => te(f, k)).map(
        Y
      ), D = N[0], y = [];
      for (let S = f.getDay(); S > 0 && D.dateObject; S--) {
        const k = te(D.dateObject, -S), F = S === 1 ? { ...D, date: k.getDate(), dateObject: k } : {};
        y.push({
          ...F,
          dateType: "empty"
        });
      }
      const v = [...y, ...N], T = 7 - v.length % 7, w = v[v.length - 1];
      if (T > 0 && T < 7)
        for (let S = 0; S < T; S++) {
          const k = S === 0 ? w : {};
          v.push({
            ...k,
            dateType: "empty"
          });
        }
      return {
        year: f.getFullYear(),
        month: f.getMonth() + 1,
        weekCount: Math.ceil(v.length / 7),
        days: v
      };
    });
  }, [t.from.toISOString(), t.to.toISOString(), t.holidays]), n = q(
    (c) => t.calendarType === "fromPastToNow" ? (i) => de(i, c) || je(i, c) : t.calendarType === "fromNowToFuture" ? (i) => ve(i, c) || je(i, c) : () => !0,
    [t.calendarType]
  ), a = E(() => {
    const c = t.today, i = n(c.getTime());
    return e.map((m) => {
      const o = m.days.map((d) => {
        const u = { ...d };
        if (u.dateType === "empty" || !u.dateObject)
          return u;
        const l = Z(u.dateObject, c), f = i(u.dateObject.getTime()), h = de(u.dateObject, t.from) && !l, g = ve(u.dateObject, t.to);
        return u.disabled = !!u.disabled || h || g || !l && !f, t.useYanoljaTime && Z(u.dateObject, Cn(c)) && (u.text = xa, u.disabled = !1), l && (u.isToday = !0), u;
      });
      return {
        ...m,
        days: o
      };
    });
  }, [t.from.toISOString(), t.to.toISOString(), t.useYanoljaTime, e]), r = E(() => {
    if (!t.selectedDate) return a;
    const [c, i] = t.selectedDate, m = !!c && se(c, "MM", { locale: Ue }), o = !!i && se(i, "MM", { locale: Ue });
    return c && !i ? a.map((d) => {
      const u = (h) => xe(h, c), l = (h) => {
        const g = u(h);
        return g < 0 ? !0 : g < (t.minDuration ?? Pa) ? !1 : g <= (t.maxDuration ?? va);
      }, f = d.days.map((h) => {
        const g = { ...h };
        return g.dateType === "empty" || g.disabled || !g.dateObject || (g.disabled = !l(g.dateObject), Z(c, g.dateObject) && (g.isFirstSelected = !0, g.isLastSelected = !0, g.isSelected = !0)), g;
      });
      return {
        ...d,
        days: f
      };
    }) : c && i ? a.map((d) => {
      const u = d.days.map((l) => {
        const f = { ...l }, h = f.dateObject;
        return h && (f.isSelected = de(h, i) && ve(h, c), f.isFirstSelected = Z(c, h), f.isLastSelected = f.dateType !== "empty" && Z(i, h), (f.isFirstSelected || f.isLastSelected) && (f.isSelected = !0), f.dateType === "empty" && m === o && (f.isFirstSelected = !1, f.isLastSelected = !1, f.isSelected = !1)), f;
      });
      return {
        ...d,
        days: u
      };
    }) : a;
  }, [a, t.selectedDate, t.maxDuration, t.minDuration]);
  return {
    calendar: E(
      () => t.adjustCalendar ? t.adjustCalendar(r) : r,
      [t.adjustCalendar, r]
    )
  };
}, Na = 179, ka = 44, Ae = 51, Ca = 6, Wa = 16, Ya = 10, st = (t) => {
  const {
    deviceType: e,
    type: n = "range",
    calendarType: a = "fromNowToFuture",
    selectedDate: r,
    holidays: s,
    header: c,
    headerHeight: i = Ya,
    footer: m,
    options: o,
    className: d,
    monthClassName: u,
    onDateChange: l
  } = t, f = e === "etc", h = E(
    () => Je(se((o == null ? void 0 : o.today) ?? K.tz("Asia/Seoul"), "yyyy-MM-dd")),
    [o == null ? void 0 : o.today]
  ), g = n === "single" ? [h, void 0] : [h, te(h, 1)], Y = r ?? g, N = he(null), [D, y] = le([]), v = E(() => D.reduce((b, { height: P }) => b + (P || 0), 0), [D]), { calendar: T } = rt({
    from: (o == null ? void 0 : o.from) ?? h,
    to: (o == null ? void 0 : o.to) ?? te(h, (o == null ? void 0 : o.maxDaysCount) ?? Na),
    selectedDate: r,
    today: h,
    calendarType: a,
    holidays: s,
    useYanoljaTime: !!(o != null && o.useYanoljaTime),
    ...o
  }), w = q(
    (b) => {
      const [P, p] = Y;
      if (!b) return;
      const B = P && !p && Z(P, b), R = !P || Y.every((I) => !!I), V = P && de(b, P);
      if (B || R || V) {
        const I = [b, void 0];
        l == null || l(I, "startDate");
      } else {
        const I = [P, b];
        l == null || l(I, "endDate");
      }
    },
    [l, Y]
  ), S = q(
    (b) => {
      if (!b) return;
      const P = [b, void 0];
      l == null || l(P, "startDate");
    },
    [l]
  ), k = q(
    (b) => {
      switch (n) {
        case "single":
          S(b);
          break;
        case "range":
          w(b);
          break;
        case "both":
          F();
          break;
        default:
          throw new Error("Invalid calendar type");
      }
    },
    [n, S, w]
  ), F = (b) => {
  };
  ge(() => {
    !(r != null && r[0]) && !(r != null && r[1]) && (l == null || l(g, "initial"));
  }, []);
  const A = q(
    (b, P) => {
      const p = [...D];
      p[P].height = b, y(p);
    },
    [D]
  );
  return gt(() => {
    const b = T.map(({ year: P, month: p, days: B, weekCount: R }, V) => {
      const I = V === 0, ie = R * Ae + // 주 단위 높이
      (R - 1) * Ca + ka + // 년월 제목
      Wa + // 월간 구분 공백
      (I ? i : 0);
      return {
        render: () => /* @__PURE__ */ M(
          Xn,
          {
            calendarSelectType: n,
            className: H("pb-16", u),
            "data-index": V,
            dayDescriptions: o == null ? void 0 : o.dayDescriptions,
            days: B,
            id: `day-picker-${P}-${p.toString().padStart(2, "0")}`,
            isPc: f,
            month: p,
            onSelectDate: k,
            styles: {
              paddingTop: I ? `${i}px` : void 0
            },
            year: P
          },
          `${P}-${p}`
        ),
        height: ie
      };
    });
    y(b);
  }, [T, i]), ge(() => {
    var C;
    if (!(r != null && r[0])) return;
    const b = r[0].getMonth() + 1, P = r[0].getFullYear(), p = T.findIndex((W) => W.year === P && W.month === b);
    if (p === -1) return;
    const B = 1.5, R = r[0].getDate(), { days: V } = T[p], I = V.findIndex((W) => W.dateType !== "empty" && W.date === R), ie = Math.max(Math.ceil(I / 7) - B, 0);
    (C = N.current) == null || C.scrollByItemIndex(p, ie * Ae);
  }, []), /* @__PURE__ */ M(
    tt,
    {
      className: d,
      footer: m,
      header: c,
      items: D,
      listHeight: v,
      onScroll: t.onScroll,
      preLoadingThreshold: (o == null ? void 0 : o.preLoadingThreshold) ?? 400,
      scrollRef: N,
      updateHeight: A,
      updateInterval: (o == null ? void 0 : o.updateInterval) ?? 50
    }
  );
};
st.displayName = "NDS.DayPicker";
De(st);
const pa = 179, it = (t) => {
  const {
    deviceType: e,
    type: n = "range",
    calendarType: a = "fromNowToFuture",
    selectedDate: r,
    holidays: s,
    footer: c,
    options: i,
    className: m,
    monthClassName: o,
    onChangePage: d,
    onChangeDate: u,
    customLastPageNode: l
  } = t, f = e === "etc", { pageSize: h = 2, adjustCalendar: g, initialPageFromSelection: Y = !0 } = i ?? {}, N = E(
    () => Je(se((i == null ? void 0 : i.today) ?? K.tz("Asia/Seoul"), "yyyy-MM-dd")),
    [i == null ? void 0 : i.today]
  ), D = [N, te(N, 1)], y = r ?? D, { calendar: v } = rt({
    from: (i == null ? void 0 : i.from) ?? N,
    to: (i == null ? void 0 : i.to) ?? te(N, (i == null ? void 0 : i.maxDaysCount) ?? pa),
    selectedDate: r,
    today: N,
    calendarType: a,
    holidays: s,
    useYanoljaTime: !!(i != null && i.useYanoljaTime),
    adjustCalendar: g,
    ...i
  }), T = E(() => {
    const C = y[0];
    if (!C || !Y) return 0;
    const W = Math.max(0, v.length - h);
    let L = -1, X = !1;
    for (let ne = 0; ne < v.length; ne++) {
      const Q = v[ne];
      if (typeof Q == "string") continue;
      const { year: ot, month: ct, days: ut } = Q;
      if (ot === C.getFullYear() && ct === C.getMonth() + 1) {
        L = ne;
        const Se = ut.find((Ce) => Ce.dateObject && Z(Ce.dateObject, C));
        X = (Se == null ? void 0 : Se.disabled) ?? !1;
        break;
      }
    }
    if (L === -1) return 0;
    const oe = X ? L - (h - 1) : L;
    return Math.max(0, Math.min(oe, W));
  }, [Y, v, y[0], h]), [w, S] = le(T), k = Math.max(1, v.length - h + 1), F = w === 0, A = w === k - 1, b = E(() => l && w === k - 1 ? [...v.slice(w, w + h - 1), "__CUSTOM_LAST_PAGE_NODE__"] : v.slice(w, w + h), [v, w, h, k]), P = (C) => {
    const W = Math.max(0, Math.min(k - 1, C));
    S(W), d == null || d({
      currentPage: W,
      isFirst: W === 0,
      isLast: W === k - 1
    });
  }, p = () => {
    P(w - 1);
  }, B = () => {
    P(w + 1);
  }, R = q(
    (C) => {
      const [W, L] = y;
      if (!C) return;
      const X = W && !L && Z(W, C), oe = !W || y.every((Q) => !!Q), ne = W && de(C, W);
      if (X || oe || ne) {
        const Q = [C, void 0];
        u == null || u(Q, "startDate");
      } else {
        const Q = [W, C];
        u == null || u(Q, "endDate");
      }
    },
    [u, y]
  ), V = q(
    (C) => {
      switch (n) {
        case "single":
          I();
          break;
        case "range":
          R(C);
          break;
        case "both":
          ie();
          break;
        default:
          throw new Error("Invalid calendar type");
      }
    },
    [R, n]
  ), I = (C) => {
  }, ie = (C) => {
  };
  return ge(() => {
    !(r != null && r[0]) && !(r != null && r[1]) && (u == null || u(D, "initial"));
  }, []), /* @__PURE__ */ ee("div", { className: H("relative", m), children: [
    /* @__PURE__ */ ee("div", { className: "absolute -top-2 z-10 flex w-full justify-between", children: [
      /* @__PURE__ */ M(
        We,
        {
          "aria-label": "이전 달",
          className: F ? "invisible" : "",
          icon: /* @__PURE__ */ M(yt, {}),
          onClick: p,
          size: "large",
          theme: "ghost"
        }
      ),
      /* @__PURE__ */ M(
        We,
        {
          "aria-label": "다음 달",
          className: A ? "invisible" : "",
          icon: /* @__PURE__ */ M(wt, {}),
          onClick: B,
          size: "large",
          theme: "ghost"
        }
      )
    ] }),
    /* @__PURE__ */ M("div", { className: "flex w-full gap-20 overflow-hidden", children: b.map((C, W) => {
      if (typeof C == "string")
        return /* @__PURE__ */ M("div", { className: "w-full", children: l }, "last-page-node");
      const { year: L, month: X, days: oe } = C;
      return /* @__PURE__ */ M("div", { className: "w-full", children: /* @__PURE__ */ M(
        ke,
        {
          className: H(o),
          "data-index": W + w * h,
          dayDescriptions: i == null ? void 0 : i.dayDescriptions,
          days: oe,
          id: `day-picker-${L}-${X.toString().padStart(2, "0")}`,
          isPc: f,
          month: X,
          onSelectDate: V,
          showWeeks: !0,
          year: L
        }
      ) }, `${L}-${X}`);
    }) }),
    /* @__PURE__ */ M("div", { className: "mt-16", children: c })
  ] });
};
it.displayName = "NDS.DayPickerPagination";
De(it);
export {
  st as D,
  it as a,
  nt as b,
  rt as u
};
